import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9l4 -4l4 4m-4 -4v14","key":"svg-0"}],["path",{"d":"M21 15l-4 4l-4 -4m4 4v-14","key":"svg-1"}]]

const IconArrowsSort = createReactComponent('outline', 'arrows-sort', 'ArrowsSort', __iconNode);

export default IconArrowsSort;